@if (headerOptions().length > 0 || excelEvent) {
  <div class="flex justify-end gap-1">
    @if (excelEvent) {
      <button
        mat-icon-button
        color="primary"
        [matTooltip]="'Descargar Excel'"
        (click)="downloadExcel()"
      >
        <mat-icon>download</mat-icon>
      </button>
    }
    @if (headerOptions().length > 0) {
      <button
        mat-icon-button
        color="primary"
        [matTooltip]="'Configurar encabezados'"
        (click)="openHeadersModal()"
      >
        <mat-icon>view_column</mat-icon>
      </button>
    }
  </div>
}
<div class="flex-1 min-h-0 h-full flex flex-col table-container-general">
  <div class="table-container">
    <div class="scroll-table overflow-auto flex-1 min-h-0 h-[inherit]">
      @if (visibleHeaders.length > 0) {
        <table
          mat-table
          [dataSource]="dataSource()"
          [multiTemplateDataRows]="hasExpansion"
          matSort
          class="w-full"
          (matSortChange)="announceSortChange($event)"
        >
          @for (header of visibleHeaders; track header.value; let indexColum = $index) {
            <!-- Iterar dinámicamente las columnas -->
            <ng-container
              [matColumnDef]="header.value"
              [sticky]="isSticky && indexColum === 0 && !isMobile"
              [stickyEnd]="isStickyEnd && indexColum === visibleHeaders.length - 1 && !isMobile"
            >
              <!-- HEADER -->

              @if (existsInSort(header.value)) {
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  class="min-w-24 text-center header-table"
                >
                  <div class="text-center">
                    {{ header.description | titlecase }}
                  </div>
                </th>
              } @else {
                <th mat-header-cell *matHeaderCellDef class="min-w-24 text-center header-table">
                  <div class="text-center">
                    {{ header.description | titlecase }}
                  </div>
                </th>
              }

              <!-- CELL -->
              <td
                *matCellDef="let element; let indexFila = index"
                [ngClass]="{
                  'bg-(--brand-azul-primario)! border-y-2! text-white text-general font-semibold border-white':
                    rowSearch(indexFila),
                }"
                class="min-w-24 text-center! text-general"
              >
                @if (indexColum === 0) {
                  @switch (true) {
                    @case (buttonEvent && !checkEvent && !hasExpansion) {
                      <button
                        mat-button
                        class="button-general-table w-auto px-2"
                        (click)="emitterButton(element[header.value], element)"
                      >
                        <mat-icon>article</mat-icon>
                        {{ element[header.value] }}
                      </button>
                    }

                    @case (!buttonEvent && checkEvent && !hasExpansion) {
                      <mat-checkbox
                        (change)="updateElement(element, header.value, $event.checked)"
                      />
                    }

                    @case (hasExpansion && !buttonEvent && !checkEvent) {
                      <button
                        mat-button
                        class="button-general-table min-w-22! px-2"
                        (click)="emitterButton(element[header.value], element)"
                      >
                        <div class="flex items-center gap-2">
                          <mat-icon>
                            {{ element.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down' }}
                          </mat-icon>
                          {{ element[header.value] }}
                        </div>
                      </button>
                    }

                    @default {
                      <ng-container
                        *ngTemplateOutlet="cellValue; context: { element, header, indexColum }"
                      />
                    }
                  }
                } @else if (indexColum === visibleHeaders.length - 1 && menuButton.length > 0) {
                  <div class="flex gap-1 justify-center px-1">
                    @for (button of menuButton; track button) {
                      @if (button.toolTip) {
                        <button
                          mat-button
                          class="button-general w-auto! px-4!"
                          (click)="endEmitter(button.key, element)"
                          [matTooltip]="button.toolTip"
                        >
                          @if (button.icon) {
                            <mat-icon>{{ button.icon }}</mat-icon>
                          }
                          @if (button.iconFile) {
                            <mat-icon [svgIcon]="button.iconFile"></mat-icon>
                          }
                          {{ button.text }}
                        </button>
                      } @else {
                        <button
                          matButton
                          class="w-auto! px-4!"
                          (click)="endEmitter(button.key, element)"
                        >
                          <div class="flex items-center gap-1">
                            @if (button.icon) {
                              <mat-icon>{{ button.icon }}</mat-icon>
                            }
                            @if (button.iconFile) {
                              <mat-icon [svgIcon]="button.iconFile"></mat-icon>
                            }
                            {{ button.text }}
                          </div>
                        </button>
                      }
                    }
                  </div>
                } @else {
                  <ng-container
                    *ngTemplateOutlet="cellValue; context: { element, header, indexColum }"
                  />
                }
              </td>
            </ng-container>

            <!-- TEMPLATE REUTILIZABLE -->
            <ng-template
              #cellValue
              let-element="element"
              let-header="header"
              let-indexColum="indexColum"
            >
              <div class="text-general min-w-24">
                @if (isBoolean(element[header.value])) {
                  <div class="flex justify-center items-center">
                    <mat-icon
                      class="w-6! h-6! text-1.5!"
                      [ngClass]="
                        element[header.value]
                          ? 'text-(--color-segundo)!'
                          : 'text-(--brand-rojo-error)!'
                      "
                    >
                      {{ element[header.value] ? 'check_circle' : 'cancel' }}
                    </mat-icon>
                  </div>
                } @else if (
                  header.value.includes('$') || (header.description ?? '').includes('$')
                ) {
                  <div class="w-full text-right tabular-nums pr-4">
                    {{ element[header.value] | currency: 'USD' : 'symbol' : '1.2-2' }}
                  </div>
                } @else if (header.value.includes('%')) {
                  {{ element[header.value] / 100 | percent: '1.2-2' }}
                } @else {
                  {{ element[header.value] ? element[header.value] : '-' }}
                }
              </div>
            </ng-template>
          }

          <!-- Filas -->
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let element"
              [attr.colspan]="visibleHeaders.length"
              class="p-0 border-none"
            >
              @if (element.isExpanded && element.detailData && element.detailData.length > 0) {
                <div class="p-4 border-b border-(--comp-subtable-border-color) text-left">
                  <div
                    class="w-full rounded-lg shadow-sm border border-(--comp-subtable-border-color) overflow-hidden"
                  >
                    <div
                      class="overflow-x-auto overflow-y-auto max-h-95 scrollbar-thin [scrollbar-color:var(--comp-table-scroll-bg)_var(--comp-table--border-scroll-bg)]"
                    >
                      <table
                        class="min-w-full divide-y divide-(--comp-subtable-divide-color) text-left border-collapse"
                      >
                        <thead class="bg-(--comp-table-cell-bg1) sticky top-0 z-10">
                          <tr>
                            @for (col of subHeaders; track col) {
                              <th
                                class="px-4 py-2.5 text-xs font-bold text-(--comp-subtable-text-secondary) uppercase tracking-wider text-center"
                              >
                                {{ col.description | translate | titlecase }}
                              </th>
                            }
                          </tr>
                        </thead>

                        <tbody
                          class="bg-(--comp-table-cell-bg1) divide-y divide-(--comp-subtable-divide-color)"
                        >
                          @for (subRow of element.detailData; track subRow) {
                            <tr class="hover:bg-(--comp-subtable-row-hover) transition-colors">
                              @for (col of subHeaders; track col; let isFirst = $first) {
                                <td
                                  class="px-4 py-2 text-general text-center font-normal"
                                  [ngClass]="
                                    isFirst
                                      ? 'text-(--comp-subtable-text-primary) font-medium'
                                      : 'text-(--comp-subtable-text-secondary)'
                                  "
                                >
                                  @if (
                                    col.value.toLowerCase().includes('amount') ||
                                    col.value.toLowerCase().includes('monto') ||
                                    col.value.includes('$') ||
                                    col.description.includes('$')
                                  ) {
                                    <span class="font-semibold text-(--comp-subtable-text-primary)">
                                      {{ subRow[col.value] | currency: 'USD' : 'symbol' : '1.2-2' }}
                                    </span>
                                  } @else {
                                    {{ subRow[col.value] ? subRow[col.value] : '-' }}
                                  }
                                </td>
                              }
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              } @else if (element.isExpanded && element.isSubLoading) {
                <div class="p-4 flex justify-center bg-slate-50/50">
                  <mat-spinner diameter="30"></mat-spinner>
                </div>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="headerKeys; sticky: true"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: headerKeys; let indexFila = index"
            class="table-row"
          ></tr>
          @if (hasExpansion) {
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="p-0 h-0!"></tr>
          }
        </table>
        @if (totalAmount) {
          <div
            class="h-13 flex justify-end px-20 items-center header-table text-(--color-text-primary)"
          >
            {{ 'tableGeneral.totalAmount' | translate }}
            {{ totalAmount | currency: 'USD' : 'symbol' : '1.2-2' }}
          </div>
        }
      } @else if (headerOptions().length > 0) {
        <div
          class="min-h-24 flex items-center justify-center text-general text-(--color-text-primary)"
        >
          No hay encabezados visibles.
        </div>
      }
    </div>
  </div>
</div>
@if (paginator()) {
  <mat-paginator
    #MatPaginatorGeneral
    [pageSize]="pageSize()"
    [class.hidden]="dataSource().data.length === 0"
    showFirstLastButtons
  ></mat-paginator>
}
